import { render, staticRenderFns } from "./CustomerAddress.vue?vue&type=template&id=86cc5294&scoped=true"
import script from "./CustomerAddress.vue?vue&type=script&lang=js"
export * from "./CustomerAddress.vue?vue&type=script&lang=js"
import style0 from "./CustomerAddress.vue?vue&type=style&index=0&id=86cc5294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cc5294",
  null
  
)

export default component.exports